import { has } from "../../../../utils/menu-context";
import lodash from "lodash";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["subStances"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if(["2"].includes(modelRef.refChoice?.key)){
                    return true
                } else {
                    lodash.remove(modelRef.subStances, row => !row.id);
                    modelRef.subStances.forEach(item => item.isDelete = true);
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["toWhom", "isFact", "discussCertification"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if(true === modelRef.isToWhom){
                    return true
                } else {
                    modelRef.toWhom = null;
                    modelRef.isFact = false;
                }
                return false;
            },
        }
    ];
};
